import { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import api from "../api/api";
import toast from "react-hot-toast";

const MandatoryRedirector = () => {
  const userId = localStorage.getItem("userId");
  const username = localStorage.getItem("username");
  const history = useHistory();
  const location = useLocation();

  // ✅ Use ref to persist mandatory survey ID across renders
  const currentMandatoryId = useRef(null);

  // Function to check for mandatory quiz/survey via API
  const checkMandatory = async () => {
    if (!userId || location.pathname.startsWith("/take/")) return;

    try {
      const res = await api.fetchMandatorySurvey(userId);
      const dataList = res.data?.data?.content;

      if (!Array.isArray(dataList)) {
        console.error("❌ Invalid response format:", res.data);
        return;
      }

      const mandatory = dataList.find(
        (item) => item.isMandatory && !item.isParticipated
      );

      if (mandatory) {
        currentMandatoryId.current = mandatory.id;
        toast.success("Mandatory quiz/survey required.");
        console.log("🚀 Redirecting to mandatory survey:", mandatory);
        history.push(`/take/${mandatory.id}`);
      } else {
        console.log("✅ No mandatory survey to take.");
      }
    } catch (err) {
      console.error("❌ Mandatory check failed:", err);
    }
  };

  // 🔒 Prevent back navigation if mandatory still exists
  useEffect(() => {
    const preventBackFromMandatory = async () => {
      if (!userId) return;

      try {
        const res = await api.fetchMandatorySurvey(userId);
        const dataList = res.data?.data?.content;
        const mandatory = dataList?.find(
          (item) => item.isMandatory && !item.isParticipated
        );

        if (
          mandatory &&
          !location.pathname.startsWith(`/take/${mandatory.id}`)
        ) {
          currentMandatoryId.current = mandatory.id;
          console.log("🔒 Blocking back navigation. Redirecting again...");
          history.replace(`/take/${mandatory.id}`);
        }
      } catch (err) {
        console.error("❌ Failed to validate back navigation:", err);
      }
    };

    preventBackFromMandatory();
  }, [location, userId, history]);

  // Initial API check
  useEffect(() => {
    checkMandatory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  // 📡 WebSocket real-time listener
  useEffect(() => {
    if (!userId || !username) return;

    // Handler for WebSocket messages
    const handleMandatoryPush = (data) => {
      console.log("🎯 Mandatory push received:", data);

      if (data.isMandatory && data.quizSurveyId) {
        currentMandatoryId.current = data.quizSurveyId;
        toast.success("Mandatory quiz/survey pushed to you.");
        console.log("🚀 Redirecting from WebSocket:", data.quizSurveyId);
        history.push(`/take/${data.quizSurveyId}`);
      }
    };

    // Connect to WebSocket
    const disconnect = api.connectWebSocket(username, handleMandatoryPush);

    // Cleanup on unmount
    return () => {
      if (disconnect) disconnect();
    };
  }, [userId, username, history]);

  return null;
};

export default MandatoryRedirector;
